import { Outlet } from 'react-router';

function DashboardLayout() {
  return (
    <div className="relative mb-8">
      <div className="relative col-span-full mx-auto flex max-w-7xl flex-col gap-y-4">
        <Outlet />
      </div>
    </div>
  );
}

export default DashboardLayout;
